import React, { createContext, useReducer } from 'react'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'set_dtc_mapping_error_data': {
      return { ...data, data: payload.data }
    }
    case 'set_selected_dtc_mapping_error_data': {
      return { ...data, selectedDtcMappingError: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedDtcMappingError: {},
}

const DtcMappingErrorsStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <DtcMappingErrorsContext.Provider value={[state, dispatch]}>
      {children}
    </DtcMappingErrorsContext.Provider>
  )
}

export const DtcMappingErrorsContext = createContext(initialState)
export default DtcMappingErrorsStore
